export default {
  // AdminUsersView
  manageUsers: 'Manage Users',
  users: 'Users',
  roles: 'Roles',

  // AdminUsersTable
  addUser: 'Add User',
  activeUsers: 'Show active users',
  inactiveUsers: 'Show deactivated users',
  cannotModifyOwnStatus: 'You cannot modify your own status',
  activateUser: 'Activate user',
  deactivateUser: 'Deactivate user (the user will not be able to access the platform)',
  deactivateUserConfirmTitle: 'Deactivate user?',
  activateUserConfirmTitle: 'Activate user?',
  deactivateUserConfirmText: 'The user will not be able to access the platform while deactivated.',
  activateUserConfirmText: 'The user will be able to access the platform again.',
  deactivateAction: 'Deactivate',
  activateAction: 'Activate',
  userDeactivatedSuccessfully: 'User deactivated successfully.',
  userActivatedSuccessfully: 'User activated successfully.',
  userInformation: 'User Information',
  sendEmailToUser: 'Send Email to Reset Password',
  editUser: 'Edit User',
  manageUserPermissions: 'Manage User Permissions.',
  copyPermissions: 'Copy Permissions',
  deleteUser: 'Delete User',
  cannotDeleteCurrentUser: 'You cannot delete the user you are logged in with',
  createUser: 'Create User',
  copyPermissionsFrom: 'Copy Permissions From',
  selectUserToCopyPermissions: 'Select the User from which you want to copy Permissions.',
  cancel: 'Cancel',
  copy: 'Copy',
  permissionsCopiedSuccessfully: 'Permissions Copied Successfully',
  userCreatedSuccessfully: 'User Created',
  emailSentSuccessfully: 'Email Sent',
  deletingUser: 'Deleting user...',
  userDeletedSuccessfully: 'User Deleted',
  filterByRole: 'Filter by role',
  clearFilter: 'Clear',
  selectRoles: 'Select roles...',
  noRolesAvailable: 'No roles available',
  superUser: 'Super User',

  // GroupNameAssignment
  createRole: 'Create Role',
  modifyRoleName: 'Modify Role Name',
  deleteRole: 'Delete Role',
  createNewRoleName: 'Create New Role Name',
  group: 'Group',
  deleteRoleConfirmation: 'Are you sure you want to delete the Role?',
  roleDeletedSuccessfully: 'Role deleted.',

  // RoleForm
  modifyRole: 'Modify Role',
  name: 'Name',
  selectPermissionType: 'You must select a permission type.',
  roleCreatedSuccessfully: 'Role created.',
  roleUpdatedSuccessfully: 'Role updated.',

  // UserForm
  firstName: 'First Name',
  firstNames: 'First Names',
  lastName: 'Last Name',
  lastNames: 'Last Names',
  email: 'Email',
  verifyEmailAvailability: 'Verify that the email is available on the platform.',
  emailAvailable: 'Email available',
  emailNotAvailable: 'This email is not available for use.',
  password: 'Password',
  passwordRequirements: 'The password must be composed of at least:',
  passwordLowercase: 'At least one lowercase letter.',
  passwordUppercase: 'At least one uppercase letter.',
  passwordNumber: 'At least one number.',
  passwordSymbol: 'At least one symbol.',
  passwordMinLength: 'Must be at least 8 characters.',
  identifierType: 'Identifier Type',
  identifier: 'Identifier',
  role: 'Role',
  selectRole: 'You must select a role.',
  mustSelect: 'You must select a',
  cohort: 'Cohort',
  cohortValidation: 'This field is required and you must enter a valid year',
  bibliographyNotifications: 'Library notifications',
  bibliographyNotificationsTooltip: 'If selected, you will receive notifications about changes in the catalog or new acquisitions.',
  userStatus: 'User Status',
  active: 'Active',
  inactive: 'Inactive',
  userUpdatedSuccessfully: 'User Updated',
  fieldRequired: 'This field is required.',
  invalidEmail: 'The email does not have a valid format.',
  minLengthError: 'This field must have at least {min} characters.',

  // AdminInstitutionView
  configuration: 'Configuration',
  logs: 'Logs',
  bulkLoading: 'Bulk loading',

  // InstitutionBulkLoading
  bulkDataLoading: 'Bulk data loading',
  howItWorks: 'How does it work?',
  bulkLoadingDescription: 'Templates are downloaded with the current platform information. Once you complete the data, contact us to process the upload.',
  downloadStepDescription: 'Download the template with the current data',
  completeStepDescription: 'Fill in the information in the Excel file',
  contactStepDescription: 'Send us the file to process it',
  availableTemplates: 'Available templates',
  bulkLoadingTemplateFor: 'Template for bulk loading of {entity}',
  downloadTemplateXLSX: 'Download XLSX template',
  generatingTemplate: 'Generating template...',
  templateDownloadedSuccessfully: 'Template downloaded successfully',

  // InstitutionLogsView
  institutionLogs: 'Institution Logs',
  institutionLogsSubtitle: 'History of changes made to the institution (records from 1 to 2 months)',
  update: 'Update',
  searchPlaceholder: 'Search by user, email or model...',
  date: 'Date',
  clearDate: 'Clear Date',
  actionType: 'Action type',
  allActions: 'All actions',
  creation: 'Creation',
  updateAction: 'Update',
  deletion: 'Deletion',
  user: 'User',
  model: 'Model',
  dateAndTime: 'Date and Time',
  action: 'Action',
  ip: 'IP',
  viewDetails: 'View details',
  logDetails: 'Log Details',
  createdObject: 'Created Object',
  deletedObject: 'Deleted Object',
  previous: 'Previous:',
  new: 'New:',

  // PermissionTable
  allowCreate: 'Allow creating {entity}',
  selectAllIncludingFuture: 'Select all (including those created later)',
  selectedCount: 'Number of selected',
  savePermissions: 'Save Permissions',
  permissionsModifiedTitle: 'Permissions Saved',
  permissionsModifiedText: 'The edit permissions have been saved. Click Continue to configure which {entity1} and {entity2} can be opened or closed.',
  permissionUpdated: 'Permission updated',

  // AccessForm
  partialLocks: 'Partial Locks',
  accessFacultyDirectorWarning: 'If the Edit or Delete permission is granted, this role will only be able to modify the objects within the {entity1} of the {entity2} selected.',
  accessInstructionalAdminWarning: 'If the Edit or Delete permission is selected, this role will only be able to modify the {entity}',
  accessCareerDirectorOrEgressWarning: 'If the Edit or Delete permission is granted, this role will only be able to modify the objects within the {entity} selected.',
  accessRequiresRole: 'To create an Access, the User must have a Role',
}
